<template>

<div class="item">

    <div class="item-text">

        <h2>{{ item.name }}</h2>

        <p>{{ item.description }}</p>

    </div>

    <div class="item-vote" v-if="!finished && !archived && $loggedin">

        <div class="item-vote-button" :class="{'is-disabled': !countFinal}" v-on:click="$emit('down')"><i class="fa fa-caret-down" /></div>

        <div class="item-vote-count" :class="{'is-zero': !countFinal}">{{ countFinal }}</div>

        <div class="item-vote-button" :class="{'is-disabled': !remaining}" v-on:click="$emit('up')"><i class="fa fa-caret-up" /></div>

    </div>

    <div class="item-result" :class="{'is-winner': item.status === 2}" v-if="finished && !archived">

        <div class="item-result-votes" :class="{'is-empty': !countFinal}" v-tooltip="'Your votes'" v-if="$loggedin && (countFinal || !window.is.mobile)">{{ countFinal }}</div>
        <div class="item-result-count" v-tooltip="'Community vote share'">{{ item.percent }}<small>%</small></div>

    </div>

    <div class="item-date" v-if="archived">

        <div class="item-date-count">{{ item.date | formatDate('MMM YYYY') }}</div>

    </div>

</div>

</template>

<script>

export default {

	props: ['item', 'count', 'finished', 'archived', 'remaining'],

    computed: {

        countFinal: function() {

            return this.count || 0

        }

    }

}

</script>

<style scoped>

.item {
    padding: 20px;
    border-bottom: 1px solid #eee;
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 40px;
}

.is-mobile .item {
    padding: 10px;
    grid-gap: 10px;
    grid-template-columns: 1fr auto;
    align-items: flex-start;
}

.item h2 {
	font-size: 16px;
	line-height: 20px;
	color: #222;
	margin-bottom: 4px;
}

.is-mobile .item h2 {
    font-size: 14px;
    line-height: 18px;
}

.item p {
	font-size: 16px;
	line-height: 20px;
	color: #222;
}

.is-mobile .item p {
    font-size: 14px;
    line-height: 18px;
}

.item:last-child {
    border-bottom: 0px;
}

.item-date {
    display: grid;
    grid-template-columns: 48px;
    align-items: center;
    justify-content: center;
}

.item-date-count {
    width: 48px;
    height: 48px;
    text-align: center;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 16px;
    background-color: #4881bb;
    color: #fff;
    border-radius: 4px;
}

.item-result {
    display: grid;
    grid-template-columns: 48px 48px;
    grid-gap: 10px;
    align-items: center;
    justify-content: center;
}

.is-mobile .item-result {
    grid-template-columns: 48px;
    align-items: flex-start;
    justify-content: flex-start;
}

.item-result-votes {
    width: 48px;
    height: 48px;
    text-align: center;
    font-weight: 700;
    line-height: 48px;
    font-size: 16px;
    background-color: #48bb6d;
    color: #fff;
    border-radius: 4px;
    color: #fff;
}

.item-result-votes.is-empty {
    opacity: 0;
}

.item-result-count {
    width: 48px;
    height: 48px;
    text-align: center;
    font-weight: 700;
    line-height: 48px;
    font-size: 16px;
    background-color: #4881bb;
    color: #fff;
    border-radius: 4px;
}

.item-result-count small {
    font-size: 12px;
    font-weight: 400;
}

.item-result.is-winner .item-result-count {
    background-color: #48bb6d;
}

.item-vote {
    display: grid;
    grid-template-columns: 32px 48px 32px;
    align-items: center;
    grid-gap: 10px;
}

.is-mobile .item-vote {
    grid-template-columns: 32px 32px;
    grid-gap: 4px;
}

.item-vote-button {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid #4881bb;
    background-color: #fff;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    color: #4881bb;
    cursor: pointer;
}

.is-mobile .item-vote-button:nth-child(1) {
    order: 2;
}

.is-mobile .item-vote-button:nth-child(3) {
    order: 3;
}

.item-vote-button:hover {
    background-color: #4881bb;
    color: #fff;
}

.item-vote-button.is-disabled {
    color: #ddd;
    pointer-events: none;
    border-color: #ddd;
}

.item-vote-count {
    width: 48px;
    height: 48px;
    text-align: center;
    font-weight: 700;
    line-height: 48px;
    font-size: 16px;
    background-color: #4881bb;
    color: #fff;
    border-radius: 4px;
}

.is-mobile .item-vote-count {
    grid-column: span 2;
    width: 100%;
    order: 1;
}

.item-vote-count.is-zero {
    background-color: #ccc;
    color: #999;
}

</style>